// @flow

const EXPECTATION_FAILED = 417;
const INTERNAL_SERVER_ERROR = 500;
const SERVICE_UNAVAILABLE = 503;

export { EXPECTATION_FAILED, INTERNAL_SERVER_ERROR, SERVICE_UNAVAILABLE };
